import {
  LOGIN_SUCCESS,
  LOGOUT_REQUEST,
  UPDATE_USER,
} from "../Actions/actionType";

const INITIAL_STATE = {
  access_token: "",
  user_type: null,
  isLogin: false,
  user: null,
};

export default (state = INITIAL_STATE, action) => {
  // console.log('in Switch Case........', action);
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload?.user,
        user_type: action.payload?.user?.UserId?.role,
        isLogin: true,
        access_token: action.payload?.token,
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        access_token: "",
        isLogin: false,
        user_type: null,
        user: null,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
};
